import React from 'react'
import './index.scss'

import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'

import CustomAvatar from '../../../../components/basic/customAvatar'
import CustomTableSimple from '../../../../components/complex/customTableSimple'
import CustomSnackbar from '../../../../components/global/snackbar'

import { api } from '../../../../functions/api'

const TIMEOUT = 3000

@inject('internal')
@inject('translate')
@inject('client')
@observer
export default class ClientBasicInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openSnackbar: false,
            message: ''
        }
    }

    componentDidMount() {
        this.setPermissions()
    }

    setPermissions() {
        let user = toJS(this.props.internal.user)

        if (user && user.data && user.data.role && (user.data.role.id < 3 || user.data.role.id === 5)) {
            this.labelsTable1.push({
                label: 'rabat_level',
                value: this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL,
                dropDown: true
            })
        }
    }

    closeSnackBar() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: '', openSnackbar: false })
        }, TIMEOUT)
    }

    timeout = null
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    updateClientData = async () => {

        let load_data = await api({
            method: 'patch',
            url: 'clients/' + toJS(this.props.client.clientData.id),
            authorization: this.props.internal.user.access_token,
            params: {
                name: toJS(this.props.internal.dataForSimpeTable.name),
                id_no: toJS(this.props.internal.dataForSimpeTable.id_no), //ICO
                id_tax: toJS(this.props.internal.dataForSimpeTable.id_tax), //DIC
                id_vat: toJS(this.props.internal.dataForSimpeTable.id_vat), //id dic
                street_name: toJS(this.props.internal.dataForSimpeTable.street_name),
                zip: toJS(this.props.internal.dataForSimpeTable.zip),
                city: toJS(this.props.internal.dataForSimpeTable.city),
                country: toJS(this.props.internal.dataForSimpeTable.country),
                rabat_level:
                    toJS(this.props.internal.dataForSimpeTable.rabat_level) === 0
                        ? null
                        : toJS(this.props.internal.dataForSimpeTable.rabat_level)
            }
        })

        if (load_data.success && load_data.success === true) {
            this.setState({ message: load_data.data.message, openSnackbar: true })
        } else {
            for (let i in load_data.data.data.errors) {
                this.setState({ message: load_data.data.data.errors[i], openSnackbar: true })
            }
        }
        this.closeSnackBar()
    }

    labelsTable1 = [
        {
            label: 'name',
            value: this.props.translate.i18n.MODULES.CLIENTS.NAME
        },
        {
            label: 'id_no',
            value: this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.ICO,
        },
        {
            label: 'id_vat',
            value: this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.IC_DPH
        },
        {
            label: 'id_tax',
            value: this.props.translate.i18n.GLOBAL.COMPANY_DETAILS.DIC
        }
        // {
        //     label: "rabat_level",
        //     value: this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL,
        //     dropDown: true
        // }
    ]

    labelsTable2 = [
        {
            label: 'street_name',
            value: this.props.translate.i18n.GLOBAL.ADRESS.ADRESS
        },
        {
            label: 'zip',
            value: this.props.translate.i18n.GLOBAL.ADRESS.ZIP
        },
        {
            label: 'city',
            value: this.props.translate.i18n.GLOBAL.ADRESS.CITY
        },
        {
            label: 'country',
            value: this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY
        }
    ]

    handleChangePhoto = async data => {

        let upload_data = await api({
            method: 'post',
            url: 'clients/' + Number(toJS(this.props.client.clientData.id)) + '/logo',
            formData: true,
            authorization: this.props.internal.user.access_token,
            params: {
                image_logo: data
            }
        })

        this.closeSnackBar()
        if (upload_data.success && upload_data.success === true) {
            this.setState({ message: upload_data.data.message, openSnackbar: true })
            return Promise.resolve(false)
        }
    }

    render() {
        return (
            <div className={'flex client-details'}>
                <CustomSnackbar
                    message={this.state.message}
                    open={this.state.openSnackbar}
                    onClose={this.handleCloseSnackbar}
                />
                <CustomAvatar
                    src={toJS(this.props.internal.dataForSimpeTable.image_logo)}
                    actionUploadPhoto={this.handleChangePhoto}
                    disableEdit={false}
                />
                <CustomTableSimple
                    updateClientData={this.updateClientData}
                    className={'w-100 m-3 ml-20 th-bold'}
                    labels={this.labelsTable1}
                    disableEdit={
                        !toJS(this.props.internal.user.data.permissions.clients.update)
                            ? true
                            : false
                    }
                />
                <CustomTableSimple
                    updateClientData={this.updateClientData}
                    className={'w-100 m-3 ml-20 th-bold'}
                    labels={this.labelsTable2}
                    disableEdit={
                        !toJS(this.props.internal.user.data.permissions.clients.update)
                            ? true
                            : false
                    }
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/basic/index.js